<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <!-- <home-banner></home-banner> -->
    <ul
      class="left-nav"
      :style="{
        left: leftBarFixLeft + 'px',
        display: !isShow ? 'none' : 'block'
      }"
    >
      <li v-for="(item, index) in curCategories" :key="item.category_id">
        <a
          :class="{ actived: item.is_checked }"
          href="javascript:void(0);"
          @click="goToItem(item, index)"
          >{{ item.name }}</a
        >
      </li>
      <li>
        <a href="javascript:void(0);" @click="goToTop">回到顶部</a>
      </li>
    </ul>
    <div>
      <div class="w">
        <div class="cat_home_wrap">
          <div class="cat_home_top">
            <p class="title">
              {{ category_products.name }}
              <!-- <span>总有你想不到的好货</span> -->
            </p>
            <div class="content">
              <div
                class="left_item"
                v-show="firstRecommend"
                @click="goGoodsDetail(firstRecommend[0].product_id)"
              >
                <p class="item_title">
                  {{ firstRecommend && firstRecommend[0].name }}
                </p>
                <p class="item_price">
                  {{ firstRecommend && firstRecommend[0].special | jifen }}
                </p>
                <p
                  class="item_oldprice"
                  v-show="
                    firstRecommend &&
                      isFalse(
                        firstRecommend[0].price,
                        firstRecommend[0].special
                      )
                  "
                >
                  {{ firstRecommend && firstRecommend[0].price | jifen }}
                </p>
                <img :src="firstRecommend && firstRecommend[0].image" alt />
              </div>
              <div class="right_box">
                <div
                  class="right_item"
                  v-for="item in recommendProducts"
                  :key="item.product_id"
                  @click="goGoodsDetail(item.product_id)"
                >
                  <p class="item_title">{{ item.name }}</p>
                  <p class="item_price">{{ item.special | jifen }}</p>
                  <p
                    class="item_oldprice"
                    v-show="isFalse(item.price, item.special)"
                  >
                    {{ item.price | jifen }}
                  </p>
                  <img :src="item.image ? item.image : defaultGoods" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="cate-item"
          :id="item.category_id"
          v-for="item in curCategories"
          :key="item.category_id"
        >
          <el-row
            :name="item.name"
            class="cate-title"
            v-if="item.products && item.products.length > 3"
          >
            <el-col :span="12">
              <a class="item-title">{{ item.name }}</a>
            </el-col>
            <el-col :span="12">
              <router-link
                :to="{
                  name: 'products-list',
                  query: {
                    type: curCategoryType,
                    category_id: item.category_id
                  }
                }"
                >更多 +</router-link
              >
            </el-col>
          </el-row>

          <el-row
            class="cate-body"
            v-if="item.products && item.products.length > 3"
          >
            <el-col
              :span="6"
              v-for="(i, index) in item.products"
              :key="i.product_id"
              v-show="index < 4"
            >
              <div>
                <img
                  :src="i.image"
                  alt="goods"
                  @click="goGoodsDetail(i.product_id)"
                />
              </div>
              <div class="goods-description">{{ i.name }}</div>
              <div class="goods-comment">
                <div
                  v-if="
                    i.product_comment_summary &&
                      i.product_comment_summary.comment_count > 10000
                  "
                >
                  <span class="comment-highlight"
                    >{{
                      parseInt(i.product_comment_summary.comment_count / 10000)
                    }}万+</span
                  >
                  <span>条评价</span>
                  <span>好评度:</span>
                  <span class="comment-highlight"
                    >{{
                      parseFloat(
                        (i.product_comment_summary.good_rate * 100).toFixed(2)
                      )
                    }}%</span
                  >
                </div>
                <div
                  v-else-if="
                    i.product_comment_summary &&
                      i.product_comment_summary.comment_count === 0
                  "
                >
                  <span class="placeholder">&nbsp;</span>
                </div>
                <div
                  v-else-if="
                    i.product_comment_summary &&
                      i.product_comment_summary.comment_count < 10000
                  "
                >
                  <span class="comment-highlight">{{
                    i.product_comment_summary.comment_count
                  }}</span>
                  <span>条评价</span>
                  <span>好评度:</span>
                  <span class="comment-highlight"
                    >{{
                      parseFloat(
                        (i.product_comment_summary.good_rate * 100).toFixed(2)
                      )
                    }}%</span
                  >
                </div>
              </div>
              <div class="goods-price">
                {{ i.special | jifen }}
                <span v-if="isFalse(i.price, i.special)">{{
                  i.price | jifen
                }}</span>
              </div>
              <div class="hover-show">
                <div>{{ i.special | jifen }}</div>
                <el-button @click="addToCart(i.product_id, i.minimum, i.sku)"
                  >加入购物车</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import HomeBanner from "@/components/home-banner";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
import { mixinUserbehv } from "@/assets/js/userbehv";

export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    HomeBanner
  },
  data() {
    return {
      curCategories: [],
      leftBarFixLeft: 0,
      curCategoryType: "",
      isShow: false,
      category_products: [],
      firstRecommend: null,
      recommendProducts: [],
      defaultGoods: DEFAULTGOODS,
      timer: null
    };
  },
  watch: {
    leftBarFixLeft(val) {
      this.leftBarFixLeft = val;
    },
    $route: {
      handler() {
        this.getData();
        this.category.map(item => {
          if (item.type == this.$route.query.type) {
            this.curCategoryType = item.type;
          }
        });
      }
    }
  },
  mounted() {
    this.category = JSON.parse(
      this.$util.getSessionStorage("category").category
    );
    this.category.map(item => {
      if (item.type == this.$route.query.type) {
        this.curCategoryType = item.type;
      }
    });
    this.getData();
    this.calLeft();
    window.onresize = () => {
      return (() => {
        this.calLeft();
      })();
    };
    window.onscroll = () => {
      this.isShow = true;
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.isShow = false;
          clearInterval(this.timer);
          this.timer = null;
        }, 3000);
      }
      this.checkIsINView();
    };
  },
  mixins: [mixinUserbehv],
  methods: {
    isFalse(price, special) {
      let oPrice = parseFloat(price);
      let oSpecial = parseFloat(special);
      if (oPrice > oSpecial) {
        return true;
      }
      return false;
    },
    getData() {
      if (this.$store.state.category.category_data) {
        this.category_format(this.$store.state.category.category_data);
        return;
      }
      this.$reqGet("api/store/category").then(res => {
        this.category_format(res.data.data);
        this.$store.commit("setCategory", res.data.data);
      });
    },
    category_format(data) {
      this.category_products = data.filter(
        item => item.category_id == this.$route.query.id
      )[0];
      let str = this.category_products.category_id;
      this.category_products.categories.map(item => {
        str += "," + item.category_id;
      });
      this.getCategoryProducts(str);
    },
    getCategoryProducts(str) {
      this.firstRecommend = "";
      this.recommendProducts = [];
      this.$reqGet("/api/ecomm/home/pc_home_product/" + str).then(res => {
        if (res.data.success) {
          for (let key in res.data.data) {
            if (key == this.category_products.category_id) {
              this.category_products.products = res.data.data[key];
            }
            this.category_products.categories.map(item => {
              if (key == item.category_id) {
                item.products = res.data.data[key];
              }
            });
          }
          if (
            this.category_products.products &&
            this.category_products.products.length > 1
          ) {
            this.firstRecommend = this.category_products.products.slice(0, 1);
            this.recommendProducts = this.category_products.products.slice(
              1,
              9
            );
          }
          this.curCategories = [];
          this.category_products.categories.map(item => {
            if (item.products && item.products.length > 3) {
              this.curCategories.push(item);
            }
          });
          this.$forceUpdate();
        }
      });
    },
    calLeft() {
      if (document.body.clientWidth - 1200 < 220) {
        this.leftBarFixLeft = 0;
        return;
      }
      this.leftBarFixLeft = (document.body.clientWidth - 1200) / 2 - 110;
    },
    goToItem(item) {
      document.getElementById(item.category_id).scrollIntoView(true);
      this.setNotChecked();
    },
    goGoodsDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/productDetail",
        query: { type: this.$route.query.type, product_id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    addToCart(id, minimum, sku) {
      this.setUserbehv(id, "cart", sku, 1);
      return this.$reqPost("api/store/cart", {
        id: id,
        qty: minimum || 1
      }).then(res => {
        if (res.data.status == 200) {
          this.$bus.emit("get-cartNum");
          this.open();
        }
      });
    },
    open() {
      this.$message({ message: "添加至购物车成功", type: "success" });
    },
    goToTop() {
      window.scrollTo(0, 0);
      this.setNotChecked();
    },
    setNotChecked() {
      this.curCategories.map(ele => {
        ele.is_checked = false;
      });
    },
    checkIsINView() {
      var box = document.getElementsByClassName("cate-item");
      //可见区域顶部高度
      var visibleTop = window.scrollY;
      //滚动条高度+视窗高度 = 可见区域底部高度
      var visibleBottom =
        window.scrollY + document.documentElement.clientHeight;
      for (var i = 0; i < box.length; i++) {
        var centerY = box[i].offsetTop + box[i].offsetHeight / 2;
        if (centerY > visibleTop && centerY < visibleBottom) {
          if (this.curCategories[i] && !this.curCategories[i]["is_checked"]) {
            this.$set(this.curCategories[i], "is_checked", true);
          }
          if (
            this.curCategories[i - 1] &&
            this.curCategories[i - 1]["is_checked"]
          ) {
            this.$set(this.curCategories[i - 1], "is_checked", false);
          }
          // this.$set(this.curCategories[i - 1], "is_checked", true);
          // this.$set(this.curCategories[i - 2], "is_checked", false);
        } else {
          if (this.curCategories[i] && this.curCategories[i]["is_checked"]) {
            this.$set(this.curCategories[i], "is_checked", false);
          }
          if (
            this.curCategories[i + 1] &&
            this.curCategories[i + 1]["is_checked"]
          ) {
            this.$set(this.curCategories[i + 1], "is_checked", false);
          }
          // this.$set(this.curCategories[i + 2], "is_checked", false);
          // this.$set(this.curCategories[i + 1], "is_checked", false);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.placeholder {
  padding: 10px;
}
.cat_home_wrap {
  background: #f7f7f7;
  padding-top: 30px;
  padding-bottom: 8px;
  .cat_home_top {
    padding: 13px 10px;
    background-color: #e2333f;
  }
  .title {
    font-size: 21px;
    color: #fff;
    margin-bottom: 7px;
    margin-top: 0;
    span {
      font-size: 15px;
    }
  }
  .content {
    background: #fff;
    height: 334px;
    overflow: hidden;
    .left_item {
      width: 240px;
      float: left;
      padding: 14px;
      border-right: 1px solid #ccc;
      height: 100%;
      box-sizing: border-box;
      img {
        width: 100%;
        padding: 14px;
        box-sizing: border-box;
        cursor: pointer;
        transition: margin-left 0.7s;
        &:hover {
          margin-left: -10px;
        }
      }
    }
    .item_title {
      font-size: 17px;
      color: #333;
      margin-bottom: 8px;
      margin-top: 8px;
      height: 22px;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      cursor: pointer;
    }
    .item_price {
      width: 110px;
      font-size: 17px;
      color: #fc0010;
      margin-bottom: 8px;
    }
    .item_oldprice {
      font-size: 12px;
      color: #999;
      margin-bottom: 8px;
      text-decoration: line-through;
    }
    .right_box {
      overflow: hidden;
      float: left;
      width: 940px;
      .right_item {
        float: left;
        width: 235px;
        height: 168px;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        position: relative;
        padding: 14px;
        box-sizing: border-box;
        img {
          position: absolute;
          right: 0;
          height: 100px;
          right: 14px;
          bottom: 14px;
          width: auto;
          cursor: pointer;
          transition: right 0.7s;
          &:hover {
            right: 30px;
          }
        }
      }
    }
  }
}
.cate-item {
  .cate-title {
    margin-top: 5px;
    .item-title {
      display: inline-block;
      font-size: 20px;
      color: rgba(0, 0, 0, 1);
      line-height: 34px;
      margin-top: 8px;
    }
    span {
      font-size: 18px;
      color: #999;
    }
    > div:last-child {
      text-align: right;
      line-height: 48px;
    }
  }
  .cate-body {
    cursor: pointer;
    border-top: 2px solid #55c3fd;
    .el-col {
      background-color: #fff;
      border: 1px solid #eee;
      height: 380px;
      &:hover {
        box-shadow: -2px 0px 5px rgba(0, 0, 0, 0.2);
        border: 0;
      }
      &:hover .goods-price {
        opacity: 0;
      }
      &:hover .goods-comment {
        display: none;
      }
      &:hover .goods-description {
        display: none;
      }
      &:hover .hover-show {
        display: block;
      }
      > div:first-child {
        text-align: center;
      }
      img {
        width: 220px;
        height: 220px;
        padding: 15px 0;
      }
      .goods-description {
        font-size: 16px;
        line-height: 21px;
        color: #000;
        height: 42px;
        padding: 0 15px;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .goods-comment {
        padding: 15px 0px 10px 15px;
        .comment-highlight {
          color: #e23a41;
        }
      }
      .goods-price,
      .hover-show > div:first-child {
        line-height: 20px;
        color: #e2333f;
        font-size: 18px;
        padding: 0 15px 15px;
        // &::first-letter {
        //   font-size: 14px;
        // }
        span {
          font-size: 14px;
          color: #666;
          text-decoration: line-through;
        }
      }
      .hover-show > div:first-child {
        margin-top: -10px;
        padding: 10px;
      }
      .hover-show {
        display: none;
        text-align: center;
        .el-button {
          width: 100%;
          height: 50px;
          background: rgba(226, 51, 63, 1);
          color: #fff;
          font-size: 18px;
          border: none;
          border-radius: 0;
          margin-top: 12px;
        }
      }
    }
  }
}
.left-nav {
  position: fixed;
  top: 50px;
  z-index: 2000;
  background: #fff;
  color: #666;
  text-align: center;
  line-height: 26px;
  > li {
    height: 25px;
    font-size: 12px;
  }
  li > a {
    height: 25px;
    padding: 0 5px;
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid #eee;
    &:hover {
      display: inline-block;
      color: #fff;
      background-color: #e2333f;
    }
    &.actived {
      color: #fff;
      background-color: #e2333f;
      border-top-color: #e2333f;
    }
  }
  &:hover {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/category/index.vue